/**
 * The provider value for the `gen_ai.provider.name` attribute.
 * @see https://developers.cloudflare.com/workers-ai/
 */
export const WORKERS_AI_PROVIDER_NAME = 'cloudflare.workers_ai';

/**
 * The Sentry origin for spans created by the Workers AI instrumentation.
 */
export const WORKERS_AI_ORIGIN = 'auto.ai.cloudflare.workers_ai';
